var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "s-steps"
  }, [_vm._l(_vm.steps, function (i, index) {
    return _c('div', {
      key: "".concat(i.order, "-").concat(index),
      staticClass: "s-steps__step",
      class: i.status
    }, [_c('div', {
      staticClass: "s-steps__circle"
    }, [i.icon_url ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": i.icon_url
      }
    }) : [_vm._v(" " + _vm._s(i.order) + " ")]], 2), _c('div', {
      staticClass: "s-steps__title"
    }, [_vm._v(_vm._s(i.title))])]);
  }), _c('div', {
    staticClass: "s-steps__bar"
  }, _vm._l(_vm.steps.length - 1, function (i) {
    return _c('span', {
      key: i,
      staticClass: "s-steps__indicator",
      class: _vm.steps[i].status
    });
  }), 0)], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }